import { getFeatureFlag } from '@fs/zion-flags'
import { FLAGS, getIsLive as getIsLiveShared, getIsPastBroadcast as getIsPastBroadcastShared } from '@fs/zion-rootstech'
import { getNowTimestamp } from './dateTimeHelpers'

/**
 * `@fs/zion-rootstech`'s `getIsLive` with this app's server-offset clock and force-live flag.
 * See docs/decisions/CDR-006-shared-live-helpers-bound-in-one-place.md
 */
export function getIsLive({ date, videoDuration, now = getNowTimestamp() }) {
  return getIsLiveShared({ date, videoDuration, now, forceLive: getFeatureFlag(FLAGS.FORCE_LIVE).isOn })
}

/**
 * `@fs/zion-rootstech`'s `getIsPastBroadcast` with this app's server-offset clock.
 * See docs/decisions/CDR-006-shared-live-helpers-bound-in-one-place.md
 */
export function getIsPastBroadcast({ date, videoDuration, nowTimestamp = getNowTimestamp() }) {
  return getIsPastBroadcastShared({ date, videoDuration, now: nowTimestamp })
}
